import { Typography } from '@design-system/components/typography/typography';
import { SubscriptionBundlesVM } from '../../viewModel/subscriptionBundles.viewModel';
import { Button } from '@design-system/components/button/button';

type SubscriptionDiscountsProps = Pick<
  SubscriptionBundlesVM['priceEditModal'],
  'discounts'
>;

export const SubscriptionDiscounts = ({
  discounts,
}: SubscriptionDiscountsProps) => {
  return (
    <div className="flex justify-between items-center">
      <div className="flex flex-col gap-2">
        <Typography variant="body" size="large">
          Promotions
        </Typography>
        <Typography variant="body" size="medium" color="N-80">
          Setup discounts for your offer
        </Typography>
      </div>
      <div className="flex flex-col gap-2 items-center">
        <Button color="primaryTonal" onClick={discounts.createDiscount}>
          Create discount
        </Button>
        <Typography variant="body" size="medium" fontWeight="normal">
          Discounts created: {discounts.count}
        </Typography>
      </div>
    </div>
  );
};
